import { rtkApi } from '@/apis/rtkApi';
import {
  CreateAgentByAdminRequest,
  GetAgentsByAdminRequest,
  GetAgentsByAdminResponse,
  UpdateAgentByAdminRequest,
} from '@/types/AgentType';

export const agentApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getAgentsByAdmin: builder.query<
      GetAgentsByAdminResponse,
      GetAgentsByAdminRequest
    >({
      query: (payload) => ({ url: `/admin/agent`, params: payload }),
      providesTags: ['Admin Agent'],
    }),
    createAgentByAdmin: builder.mutation<void, CreateAgentByAdminRequest>({
      query: (request) => ({
        url: `/admin/agent`,
        method: 'POST',
        data: request,
      }),
      invalidatesTags: ['Admin Agent'],
    }),
    updateAgentByAdmin: builder.mutation<void, UpdateAgentByAdminRequest>({
      query: (request) => ({
        url: `/admin/agent/${request.id}`,
        method: 'PUT',
        data: request,
      }),
      invalidatesTags: (_response, _result, request) => [
        'Admin Agent',
        { type: 'Admin Agent', id: request.id },
      ],
    }),
    removeAgentByAdmin: builder.mutation<void, string>({
      query: (agentId) => ({
        url: `/admin/agent/${agentId}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Admin Agent'],
    }),
    assignAgentToContract: builder.mutation<
      { message: string; emailSent?: boolean; reassignedFrom?: string | null },
      { agentId: string; contractId: string }
    >({
      query: ({ agentId, contractId }) => ({
        url: `/agent/add-property/${agentId}`,
        method: 'POST',
        data: { contractId },
      }),
      // Assigning can create the agent's account and changes the contract.
      invalidatesTags: ['Admin Agent', 'Admin User', 'Contract'],
    }),
    /** Link a seller (by email) to a contract; creates their account if needed. */
    linkSellerToContract: builder.mutation<
      { message: string; emailSent?: boolean },
      { contractId: string; name?: string; email: string }
    >({
      query: ({ contractId, name, email }) => ({
        url: `/admin/contract/${contractId}/seller`,
        method: 'POST',
        data: { name, email },
      }),
      invalidatesTags: ['Admin User', 'Contract'],
    }),
  }),
});

export const {
  useGetAgentsByAdminQuery,
  useCreateAgentByAdminMutation,
  useUpdateAgentByAdminMutation,
  useRemoveAgentByAdminMutation,
  useAssignAgentToContractMutation,
  useLinkSellerToContractMutation,
} = agentApi;
